import { createFileRoute, notFound } from '@tanstack/react-router';

import { ConfirmRoute } from '@mint-emails/recommendation/routes';
import { Recommendations } from '@mint-lib/api-sdk/emails';
import { z } from 'zod';

export const Route = createFileRoute('/recommendation/confirm')({
  beforeLoad: (props) => {
    if (!props.search.token) {
      throw notFound();
    }
    return props;
  },
  component: RouteComponent,
  loaderDeps: ({ search }) => ({ token: search.token }),
  loader: async ({ deps, context }) => {
    const queryClient = await context.getInstance('queryClient');
    const recommendationData = await queryClient.ensureQueryData(
      Recommendations.getRecommendation({ params: { token: deps.token } }),
    );
    return { recommendationData, token: deps.token };
  },
  validateSearch: z.object({
    token: z.string(),
  }),
});

function RouteComponent() {
  return <ConfirmRoute />;
}
